import clsx from "clsx";
import Warning from "../../src/assets/svg/warning.svg";

export interface FormInputProps {
  name: string;
  placeholder: string;
  required: boolean;
  value: string;
  type?: string;
  readOnly?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  width?: string;
  className?: string;
  errors?: string[];
  inputRefs: React.MutableRefObject<Record<string, HTMLInputElement | null>>;
}

export function FormInput(props: FormInputProps) {
  const {
    name,
    placeholder,
    required = true,
    type = "text",
    readOnly,
    value,
    onChange,
    width,
    className,
    errors,
    inputRefs,
  } = props;

  const isError = errors && errors.includes(name);

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={name} className="text-sm font-medium ">
        {name}
        {required && (
          <span className="pl-1 text-sm text-warning-red tracking-tightest">
            *
          </span>
        )}
      </label>
      <div className="flex flex-col gap-1">
        <input
          ref={(el) => (inputRefs.current[name] = el)}
          type={type}
          id={name}
          name={name}
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          maxLength={50}
          pattern={type === "email" ? "^[^s@]+@[^s@]+.[^s@]+$" : ""}
          className={clsx(
            "inline-flex w-full justify-between rounded border p-3 focus:border-primary-blue appearance-none focus:outline-none text-[15px] ",
            isError ? "border-warning-red" : "border-extra-light",
            width,
            className,
            readOnly && "bg-gray-dark text-opacity-50 focus:!border-extra-light"
          )}
        />
        {isError && (
          <div className="flex items-center gap-1 text-xs text-warning-red">
            <img src={Warning} alt="Warning" />
            Ovo polje je obavezno.
          </div>
        )}
      </div>
    </div>
  );
}

export default FormInput;
